// in styled components will be
// @media all and (min-width: ${mediaBreak})
export const phoneMediaBreak = 320;
export const desktopMediaBreak = 768;
